@import "../button/style.css";

:host() {
	margin: 1em 0em;
}
